"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DomEvents = require("../utils/DomEvents");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var UIForm =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UIForm, _React$Component);

  function UIForm() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIForm)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleKeyDown = function (evt) {
      var _this$props = _this.props,
          onKeyDown = _this$props.onKeyDown,
          onSubmit = _this$props.onSubmit;
      var key = evt.key;
      var inputFocused = document.activeElement instanceof HTMLInputElement;

      if (key === 'Enter') {
        if (evt.metaKey || evt.ctrlKey && !inputFocused) {
          if (onSubmit) onSubmit((0, _SyntheticEvent.default)());
        }
      }

      if (onKeyDown) onKeyDown(evt);
    };

    return _this;
  }

  (0, _createClass2.default)(UIForm, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          action = _this$props2.action,
          className = _this$props2.className,
          children = _this$props2.children,
          __onKeyDown = _this$props2.onKeyDown,
          onSubmit = _this$props2.onSubmit,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "className", "children", "onKeyDown", "onSubmit"]);
      return (
        /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
        _react.default.createElement("form", (0, _extends2.default)({}, rest, {
          className: (0, _classnames.default)('private-form', className),
          action: action,
          onKeyDown: this.handleKeyDown,
          onSubmit: !action && !onSubmit ? _DomEvents.preventDefaultHandler : onSubmit
        }), children)
        /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */

      );
    }
  }]);
  return UIForm;
}(_react.default.Component);

exports.default = UIForm;
UIForm.propTypes = {
  action: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  onSubmit: _propTypes.default.func
};
UIForm.displayName = 'UIForm';
module.exports = exports.default;